import React from "react";
import Placeholder from "./Placeholder";

const PlaceholderContainer: React.FC = () => {
  return (
    <>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="mt-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
      <div className="my-1">
        <Placeholder />
      </div>
    </>
  );
};

export default PlaceholderContainer;
